import { mergeDeepMissing } from '@shared/utils/mergeDeepMissing.js';
import { USER_WORKSPACE_STATE_KEYS } from '@shared/schema/userWorkspaceStateKeys.js';

const mergeUserStatePrefs = ({ prefs, workspaceRegion, remotePrefs, remoteWorkspaceRegion }) => {
  const localPrefs = { ...prefs };
  if (remoteWorkspaceRegion && remoteWorkspaceRegion !== workspaceRegion) {
    for (const key of USER_WORKSPACE_STATE_KEYS) {
      delete localPrefs[key];
    }
  }
  return mergeDeepMissing(localPrefs, remotePrefs);
};

export default mergeUserStatePrefs;
